module.exports = __webpack_public_path__ + "img/carrefour_angrignon.46742ca8.png";